export const environment = {
  production: true,
  buildId: '13300-20261020.2'
};

